import { addChannel } from "../../../../../actions/Utilities/Channel";
import { useMutation } from "react-query";

const useAddChannel = () => {
  return useMutation(addChannel);
};
export default useAddChannel;
